export default {
  methods: {
    phone(value) {
      value = `tel:+` + value.replace(/[^0-9]/g, "");
      window.location.href = value;
    },
  },
};
